import forEach from 'lodash/forEach';
import isNil from 'lodash/isNil';

export default {
  isEmpty(value, allowEmptyString) {
    // NOTE: ExtJs 소스 참고
    return value === null || (!allowEmptyString ? value === '' : false) || (Array.isArray(value) && value.length === 0);
  },
  // NOTE: Ext.isFunction
  // isFunction:
  //   typeof document !== 'undefined' && typeof document.getElementsByTagName('body') === 'function'
  //     ? function(value) {
  //         return !!value && toString.call(value) === '[object Function]';
  //       }
  //     : function(value) {
  //         return !!value && typeof value === 'function';
  //       },
  isIE() {
    const myNav = navigator.userAgent.toLowerCase();
    return myNav.indexOf('msie') !== -1 ? Number(myNav.split('msie')[1]) : false;
  },
};

/**
 * Object를 query string으로 가공하여 반환한다.
 * @author Ju
 * @param  {Objet} obj 파라미터 객체
 * @return {String}
 */
export function convertObjectToQueryString(obj) {
  const str = [];
  forEach(obj, (value, key) => {
    if (!isNil(value)) {
      str.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  });
  return str.join('&');
}



// WEBPACK FOOTER //
// ./src/utils/common.js